import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

window.addEventListener('error', (event) => {
  const message = event?.message || event?.error?.message;
  if (message === 'ResizeObserver loop completed with undelivered notifications.' || message === 'ResizeObserver loop limit exceeded.') {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js?v=20261002-owner-optional-2fa-hero-upload').catch(() => {}));
}

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
